import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { financeApi } from '../../api';
import { CustomerFinance } from './getCustomer';

export function useQueryGetUnitHaveAWSKey(
  id: string,
): UseQueryResult<{ data: CustomerFinance }> {
  return useQuery<{ data: CustomerFinance }>(
    ['UnitHaveAWSKeys', id],
    () => financeApi.get(`checkouts/verificationPreCheckout/unit/${id}`),
    {},
  );
}
